import { Col, Form, Input, Row } from '@pankod/refine-antd';

export const ModifiedAddressFormItem: React.FC = () => {
  return (
    <>
      <Row gutter={[32, 40]}>
        <Col span={12}>
          <Form.Item label="Street" name={['address', 'street']}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Area" name={['address', 'area']}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[32, 40]}>
        <Col span={12}>
          <Form.Item label="City" name={['address', 'city']}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Country" name={['address', 'country']}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[32, 40]}>
        <Col span={12}>
          <Form.Item label="Zip" name={['address', 'zip']}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
